export enum CollatorType {
  MARKETPLACE_PROJECTS = 'marketplace-projects',
  PROVISIONING_CONSUMABLES = 'provisioning-consumables',
}
